import { negate } from "lodash";
import http from "./request";

/**
 * 权限
 * @param {*} key
 */
export function hasPermission (key) {
  return window.SITE_CONFIG['permissions'].indexOf(key) !== -1 || false
}

/**
 * 获取字典数据列表
 * @param dictType  字典类型
 */
export function getDictDataList (dictType) {
  const type = window.SITE_CONFIG['dictList'].find((element) => (element.dictType === dictType))
  if (type) {
    return type.dataList
  } else {
    return []
  }
}

/**
 * 获取字典名称
 * @param dictType  字典类型
 * @param dictValue  字典值
 */
export function getDictLabel (dictType, dictValue) {
  const type = window.SITE_CONFIG['dictList'].find((element) => (element.dictType === dictType))
  if (type) {
    const val = type.dataList.find((element) => (element.dictValue === dictValue + ''))
    if (val) {
      return val.dictLabel
    } else {
      return dictValue
    }
  } else {
    return dictValue
  }
}

/**
 * 记录用户行为
 * @param {*} obj 入参
 */
export function recordLog (obj) {
  
  http({
    url: http.adornUrl(`/userRecord/log/save`),
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    data: http.adornData(obj, false)
  }).then(({ data }) => {
    if (data && data.code === 0) {
      // alert(JSON.stringify(obj))
    }
  })
  
}
export function formatDate(date,formatType) {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + date.getHours()).slice(-2);
  const minutes = ('0' + date.getMinutes()).slice(-2);
  const seconds = ('0' + date.getSeconds()).slice(-2);
  let res = ''
  switch (formatType) {
    case 'yyyy-mm':
      res = `${year}-${month}`
      break;
    case 'yyyy-mm-dd':
      res = `${year}-${month}-${day}`
      break;
    case 'yyyy-mm-dd hh':
      res = `${year}-${month}-${day} ${hours}`
      break;
    case 'yyyy-mm-dd hh:mm':
      res = `${year}-${month}-${day} ${hours}:${minutes}`
      break;
    case 'yyyy-mm-dd hh:mm:ss':
      res = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      break;
    default:
      break;
  }
  return res;
}
// 获取最近n个月
export function getRecentMonths(n) {
  let dataArr = [];
  let data = new Date();
  let year = data.getFullYear();
  data.setMonth(data.getMonth() + 1, 1); //获取到当前月份,设置月份
  for (let i = 0; i < n; i++) {
    data.setMonth(data.getMonth() - 1); //每次循环一次 月份值减1
    let m = data.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    // 年月
     dataArr.push(data.getFullYear() + "-" + m);
    // 月份
    //  dataArr.push( m+'月');
  }
  dataArr.reverse()
  return dataArr;
  // console.log("dataArr", dataArr);
}

export function getDateArry(startDate,endDate) {
  var d1 = startDate;
  var d2 = endDate;
  var dateArry = new Array();
  var s1 = d1.split("-");
  var s2 = d2.split("-");
  var mCount = 0;
  if (parseInt(s1[0]) < parseInt(s2[0])) {
      mCount = (parseInt(s2[0]) - parseInt(s1[0])) * 12 + parseInt(s2[1]) - parseInt(s1[1])+1;
  } else {
      mCount = parseInt(s2[1]) - parseInt(s1[1])+1;
  }
  if (mCount > 0) {
      var startM = parseInt(s1[1]);
      var startY = parseInt(s1[0]);
      for (var i = 0; i < mCount; i++) {
          if (startM < 12) {
              dateArry[i] = startY + "-" + (startM>9 ? startM : "0" + startM);
              startM += 1;
          } else {
              dateArry[i] = startY + "-" + (startM > 9 ? startM : "0" + startM);
              startM = 1;
              startY += 1;
          }
      }
  }
  return dateArry;
}
export function openUrl(url) {
  window.open(url,'_blank')
}

